/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureSubscriptionDetails {
    getFixupPrototypeFunction() { return AzureSubscriptionDetails.fixupPrototype; }

    static newInstance(model: Partial<AzureSubscriptionDetails>): AzureSubscriptionDetails {
        let obj = Object.assign(new AzureSubscriptionDetails(), model);
        AzureSubscriptionDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureSubscriptionDetails>): AzureSubscriptionDetails {
        if (!model) return null;
        return AzureSubscriptionDetails.newInstance(<AzureSubscriptionDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureSubscriptionDetails) {
        if (!obj) return;

        models.AzureSubscriptionDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureSubscriptionDetails): boolean {
        Object.setPrototypeOf(obj, AzureSubscriptionDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Subscription Id
     */
    subscription_id: string;

    /**
     * Subscription Name
     */
    name: string;

    /**
     * Azure Subscription Status
     */
    status: models.AzureSubscriptionStatus;

}
